import { motion } from 'framer-motion';
import SectionHeading from '../../../components/ui/SectionHeading';
import Button from '../../../components/ui/Button';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import notreEtab from '../../../assets/images/NotreEtab.png';

const AboutSection = () => {
  return (
    <div className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="order-2 md:order-1"
          >
            <SectionHeading
              title="Notre établissement"
              subtitle="À propos de nous"
            />
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Le Groupe Scolaire Sanaa est un pionnier de l'enseignement à Casablanca, doté d'une expérience de plus de Vingt ans, desservant la maternelle, le primaire, le collège et le lycée avec un enseignement solidement ancré dans la pédagogie du 21ème siècle et construit autour d'un programme multilingue.
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Notre mission est de former des citoyens responsables, créatifs et ouverts sur le monde, capables de s'adapter aux défis futurs tout en restant attachés à leurs valeurs culturelles.
            </p>
            
            <Button 
              to="/notre-ecole" 
              variant="primary"
              icon={<ArrowRightIcon className="h-5 w-5" />}
            >
              En savoir plus
            </Button>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="order-1 md:order-2"
          >
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-32 h-32 bg-primary rounded-tl-3xl z-0"></div>
              <img 
                src={notreEtab}
                alt="Élèves en classe au Groupe Scolaire Sanaa" 
                className="rounded-lg shadow-elegant w-full h-full object-cover relative z-10"
              />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-secondary rounded-br-3xl z-0"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;